<template>
  <v-container fill-height style="max-width:100%;padding:0;">
    <v-row style="height:100%;">
      <v-col style="height:100%;padding:0;">
        <v-card :elevation="5" class="card-style">
          <div class="card-style-title">
            Access to bikes
            <div class="btnCont">
              <iframe-modal :id="id" :src="src" :width="850" :height="700" />
              <v-btn
                depressed
                rounded
                color="#00486b"
                style="color:#fff"
                width="7em"
                :href="mapDatasetUrls"
                target="_blank"
              >
                Data
              </v-btn>
            </div>
          </div>
          <v-container v-if="overlay">
            <v-overlay :absolute="true" :value="overlay">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
          </v-container>
          <v-container v-if="!overlay" style="margin:10px;max-width:100%;">
            <v-row style="margin:10px 0;">
              <v-col cols="12" xs="12" sm="12" md="12">
                <div class="description">
                  <p>
                    The top 5 local authorities where residents have access to at least one bike for
                    private use [2018]
                  </p>
                  <p class="subtext">
                    This is compared to the national figure of 36%
                  </p>
                  <p class="source">
                    <span>
                      Data Source: Transport and Travel in Scotland, Scottish Household Survey
                    </span>
                  </p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12">
                <HorizontalBarChart
                  id="top5Access"
                  :data="results"
                  :y-axis="yAxis"
                  :x-axis="xAxis"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import HorizontalBarChart from '@/components/horizontalBarChart.vue';
import iframeModal from '@/components/iframeModal.vue';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '../assets/css/material-design-iconic-font.min.css';

export default {
  components: {
    HorizontalBarChart,
    iframeModal,
  },
  data() {
    return {
      results: [],
      overlay: true,
      xAxis: { label: 'Value' },
      yAxis: { label: 'Authority' },
      value: 0,
      logo: 'fas fa-bicycle',
      id: 'top5accesstobikes',
      src: 'top5accesstobikes',
    };
  },
  computed: {
    ...mapGetters(['compositeDataset']),
    mapDatasetUrls() {
      let d = null;
      if (this.compositeDataset && this.compositeDataset.top5AccessToBikesDataset) {
        d = this.compositeDataset.top5AccessToBikesDataset.dataset;
        this.content(this.compositeDataset.top5AccessToBikesDataset.apiResource);
      } else {
        console.error('No API Resource: ( top5AccessToBikesDataset )');
      }
      return d;
    },
  },
  methods: {
    async content(resource) {
      const params = { datasetGUID: resource };
      const newResults = await this.$store.dispatch('fetchData', params);
      this.results = newResults.data;
      let highest = null;
      this.results.forEach((result, index) => {
        const val = parseFloat(result.Value);
        if (highest === null || val > highest.value) highest = { value: val, index };
      });
      // this.results.splice(highest.index, 1);
      this.value = highest.value;
      this.overlay = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-style {
  padding: 2em;
  width: 100%;
  height: 100%;
  justify-content: center;
}
.description {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  p {
    font-size: 1em;
    font-weight: bold;
  }
  .subtext {
    font-size: 0.8em;
  }
  .source {
    font-weight: bold;
    font-size: 0.8em;
    font-style: italic;
  }
}
@media (min-width: 650px) {
  .description {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    p {
      font-size: 1.2em;
      font-weight: bold;
    }
    .subtext {
      font-size: 1em;
    }
  }
}
</style>
